import Backbone from 'backbone'
import Rotator from './support/rotator'
import Resizer from './support/resizer'
import leftClick from './left-click'
import _ from 'lodash'
import Paintable from './support/paintable'

var WobView = Backbone.View.extend({

  className: 'wob-control',

  attributes: function () {
    // Slap a data-id attribute on the wob control view that matches the wob model cid
    return {
      'data-wob-control-id': this.model.cid
    }
  },

  /*
   * Builds the view for the wob.
   */
  initialize: function (options) {
    // readonly might be set by the canvas and passed in as a constructor option
    this.readonly = typeof options.readonly === 'undefined' ? false : options.readonly
    this.wobView = options.wobView

    // individual wobs may also be readonly even when the canvas isn't
    if (this.model.get('readonly') === true) {
      this.readonly = true
    }

    this.canvas = options.canvas

    this.unpaddedControls = options.unpaddedControls || false

    // Read only wobs cannot be selected
    if (!this.readonly) {
      // When the wob is selected...
      this.listenTo(this.model, 'change:selected', function (wob, bool) {
        this.$el.toggleClass('selected', bool)
      }, this)

      // Only build the rotator if it's a rotatable wob
      if (this.model.widget.rotatable) {
        this.rotator = new Rotator({wob: this.model, canvas: this.canvas, el: this.el})
      }
    }

    this.listenTo(this.model, 'destroy remove', function () {
      this.release()
    })

    this.listenTo(this.model, 'change', (model, opts) => this.paint(opts.animate))
    this.listenTo(this.model, 'resize move change:rotate', () => this.paint())
  },

  render: function () {
    if (this.model.resizable && !this.readonly) {
      this.resizer = new Resizer({wob: this.model, canvas: this.canvas, el: this.el})
    }

    if (this.unpaddedControls) {
      // Used when a widget has the class, this prevents building large
      // click targets (default) on resize handlers
      this.$el.addClass('unpadded-resize-controls')
    }

    if (this.readonly) {
      this.$el.addClass('read-only')
    }

    if (this.selectable) {
      this.$el.addClass('selectable')
    }

    this.paint()
    return this
  },

  /*
   * Sets the correct css classes based on the wobs rotation
   */
  rotate: function (wob, angle) {
    this.$el.css('transform', angle ? 'rotate(' + angle + 'deg)' : '')
            .toggleClass('wob-0-degrees', angle >= 315 || angle < 45)
            .toggleClass('wob-90-degrees', angle >= 45 && angle < 135)
            .toggleClass('wob-180-degrees', angle >= 135 && angle < 225)
            .toggleClass('wob-270-degrees', angle >= 225 && angle < 315)
            .toggleClass('rotated', !!angle)
  },

  props: function () {
    var props = _.pick(this.model.toJSON(), 'width', 'height', 'left', 'top', 'rotate')
    props['z-index'] = this.model.getZindex()
    return props
  },

  addWidgetViewControl: function (v) {
    this.widgetViewControl = v
    this.$el.append(v.el)
    v.render()
  },

  release: function () {
    this.resizer && this.resizer.release()
    this.rotator && this.rotator.release()
    this.widgetViewControl && this.widgetViewControl.remove()
    this.resizer = null
    this.remove()
  }
})

_.extend(WobView.prototype, Paintable)

export default WobView
